export default "__VITE_ASSET__D3tmUK4p__"